import { LuCircleHelp } from "react-icons/lu";
import { useUserSubscription } from "../../../core_stores/useSubscriptionStore";
import { colors, typography } from "../../../design/tokens";
import { formatTokensNumber } from "../../../utils/numberFormatter";

export default function SubscriptionsRemainingTokens() {
  const subscription = useUserSubscription();

  return (
    <div className="flex flex-col gap-2 text-center">
      <div className={`${typography.size.sm} ${colors.text.secondary}`}>
        You are currently on the{' '}
        <span className={`${typography.weight.semibold} ${colors.text.primary}`}>
          {subscription?.plan}
        </span>{' '}
        plan.
      </div>
      <div className={`${typography.size.sm} ${colors.text.secondary} flex flex-wrap items-center justify-center gap-x-1`}>
        <span>Tokens remaining in current period:</span>
        <span>
          <span className={`${typography.weight.semibold} ${colors.text.primary}`}>
            {formatTokensNumber(subscription?.remaining ?? 0)}
          </span>{(subscription?.remaining ?? 0) > 0 && ','}
        </span>
        {(subscription?.remaining ?? 0) > 0 && (
          <>
            <span>active until:</span>
            <span className={`${typography.weight.semibold} ${colors.text.primary}`}>
              {subscription?.period.end}
            </span>
          </>
        )}
        <span
          className={`${colors.text.secondary} cursor-pointer inline-flex`}
          data-tooltip-id="remaining-tokens-tooltip"
        >
          <LuCircleHelp size={16} />
        </span>
      </div>
    </div>
  );
}
